<template>
    <div>
        <!-- Button trigger modal -->
        <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login"
            style="display:none;">
        </button>
        <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle"
            style="display:none;"></button>
        <login v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        <historialIngresos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        <register ref="register" v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        <nav v-if="user.token !== ''" class="navbarCustom navbar-dark py-0" id="mainHeader">
            <myAccountJM v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <div class="d-flex p-2 py-2" style="width:100%;max-height: 50px;" :style="skin.header_mobil.nav_bar">
                <span style="width: 10%;" class="position-relative me-2 my-1" data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                    <span style="font-size: large;"><i class="fas fa-bars"></i></span>
                </span>
                <div class="float-left py-2 text-center" @click="change_view('lobby')"
                    style="cursor:pointer;display:flex;justify-content: center;align-items: center;">
                    <img v-if="skin.header_mobil.logo != ''" :src="skin.header_mobil.logo"
                        :width="skin.header_mobil.logo_width" alt="">
                </div>
                <div style="width: 90%;" class="d-flex" :style="skin.header_desktop.nav_bar_text">

                    <div v-if="user.token != ''" class="px-2 pe-2 text-center" style="display:table;width: 75%;">
                        <div v-if="skin.header_desktop.balance" class="nav-item"
                            :class="skin.my_account.myaccount_type == 'JM' ? '' : 'text-end'"
                            style="cursor:pointer;width:33%;display:table-cell;vertical-align:middle;font-size: 15px;"
                            :style="skin.header_desktop.nav_bar_text">
                            <div style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;" class="text-center"
                                :style="skin.header_desktop.login_btn">
                                <div class="p-2 d-flex" style="cursor:pointer; border-radius: 6.25rem;"
                                    :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                    <span class="mx-2">{{ user.user_data.data ? new
                                        Intl.NumberFormat("de-DE", {
                                            minimumFractionDigits:
                                                skin.qBet_config.decimalsQty, maximumFractionDigits:
                                                skin.qBet_config.decimalsQty
                                        }).format(balance.saldo) : 0 }}</span>
                                    <span style="color:#9583A0;" class="mx-2">{{ user.user_data?.data?.currency
                                        }}</span>
                                </div>
                            </div>
                            <!-- <i @click="showBalanceAction" class="fas fa-coins pr-0 mx-2"></i>
                            <span v-if="showBalance">{{ user.user_data.data ? new Intl.NumberFormat("de-DE",{minimumFractionDigits: skin.qBet_config.decimalsQty,maximumFractionDigits: skin.qBet_config.decimalsQty}).format(balance.saldo) : 0 }}</span> -->
                        </div>
                    </div>
                    <div v-if="user.token == '' && skin.register" @click="register"
                        style="cursor:pointer;display:table;width: 40%;" :style="skin.header_desktop.register_btn"
                        class="py-2 px-2 pe-2 text-center">
                        <span style="display:table-cell;vertical-align:middle;">{{ translate("sign_in") }}</span>
                    </div>
                    <div v-if="user.token != ''" style="display:table;cursor:pointer;width:25%"
                        class="py-0 my-0 pb-1 text-center nav-item dropdown dropstart" data-bs-toggle="modal"
                        data-bs-target="#myAccountJm">
                        <div style="cursor:pointer;overflow: hidden;border-radius: 50%;" class="text-center"
                            :style="skin.header_desktop.login_btn">
                            <div class="p-2" style="cursor:pointer;border-radius: 50%;"
                                :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                <svg style="width: 1.3rem;height: 1.3rem;" viewBox="0 0 28 28" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.927" fill-rule="evenodd" clip-rule="evenodd"
                                        d="M12.9135 3.03401C15.0685 2.82516 16.7883 3.57826 18.0732 5.29327C19.2707 7.30272 19.2503 9.29735 18.0121 11.2773C16.2174 13.4382 14.009 13.998 11.387 12.9564C9.1058 11.6401 8.17969 9.67599 8.6087 7.06404C9.06434 5.32624 10.1126 4.09488 11.7533 3.36984C12.1402 3.23005 12.5269 3.1181 12.9135 3.03401ZM13.1578 4.01098C15.535 3.92135 17.0921 5.00011 17.8289 7.24722C18.1823 9.29814 17.4801 10.8756 15.7223 11.9795C13.93 12.8051 12.2813 12.5812 10.7764 11.3078C9.3153 9.68283 9.10159 7.90186 10.1352 5.96494C10.8817 4.90504 11.8892 4.25376 13.1578 4.01098Z"
                                        fill="white" stroke="white" stroke-width="1.04211"></path>
                                    <path opacity="0.941" fill-rule="evenodd" clip-rule="evenodd"
                                        d="M8.63947 15.6562C12.0386 15.646 15.4376 15.6562 18.8367 15.6867C20.6071 15.9309 21.8792 16.857 22.653 18.465C23.4354 20.6559 22.9571 22.5182 21.2181 24.0521C20.6491 24.466 20.0181 24.7509 19.3252 24.9069C15.7446 25.007 12.1623 25.0273 8.57841 24.968C6.28838 24.5505 4.93484 23.197 4.51785 20.9074C4.35399 18.68 5.25974 17.0619 7.23507 16.0531C7.69736 15.8716 8.16552 15.7393 8.63947 15.6562ZM8.94478 16.6331C12.1404 16.6229 15.3359 16.6331 18.5314 16.6637C20.6885 16.9584 21.8487 18.1898 22.0119 20.3579C21.8942 22.2513 20.9172 23.442 19.0809 23.9299C15.6834 24.0297 12.2843 24.05 8.88372 23.991C7.12241 23.7358 6.01312 22.7487 5.55589 21.0295C5.32764 19.1013 6.09091 17.7274 7.84568 16.9079C8.21076 16.776 8.57713 16.6844 8.94478 16.6331Z"
                                        fill="white" stroke="white" stroke-width="1.04211"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <nav v-else class="navbarCustom navbar-dark py-0" id="mainHeader">
            <div class="d-flex" :style="skin.header_mobil.nav_bar" style="width: 100%;min-height: 50px;">

                <span style="width: 10%;" class="position-relative me-2 py-2" data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                    <span style="color:#ccc;font-size: large;"><i class="fas fa-bars"></i></span>
                </span>
                <div style="width: 100%;"><img class="my-1 mx-2 py-2" :src="skin.header_mobil.logo"
                    :width="skin.header_mobil.logo_width" alt="" style="max-width: 170px;max-height: 45px;">
                </div>
                <div v-if="(user.token == '' && skin.register)" class="p-1"
                    style="width: 28.5%;border-radius: 6.25rem;">
                    <div class="p-2 text-center" @click="register"
                        style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_mobil.nav_bar_text + skin.header_desktop.register_btn">
                        <span>{{ translate("sign_in") }}</span>
                    </div>
                </div>
                <div :style="skin.header_mobil.login_btn" class="p-1" style="width: 30%;">
                    <div class="p-2 text-center" @click="login"
                        style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_mobil.nav_bar_text + skin.header_desktop.selection">
                        <span style="font-size: 14px; white-space: nowrap;"> {{ translate("log_in") }}</span>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import myAccountJM from "./my_account.vue";
import login from "./login_mobil.vue";
import register from './register.vue';
import historialIngresos from "./historialIngresos.vue";
export default {
    name: "header_mobil",
    props: ["skin", "translation", "language"],
    components: { myAccountJM, login, register, historialIngresos },
    data() {
        return {
            userDataLoaded: false,
            showBalance: false,
            supportTickets: [],
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            },
        }
    },
    computed: {
        jivo_modal_flag() {
            return this.$store.getters["getModalFlag"]
        },
        message_recived() {
            return this.$store.getters["getMessage"]
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },
        currency() {
            return this.$store.getters['getCurrency'];
        },
    },
    methods: {
        action() {
            let customButton = this.$props.skin.customActionButton;
            if (customButton.action == 'redirection') {
                let url = customButton.actionData.url;
                let parameters = customButton.actionData.parameters;
                parameters.forEach(param => {
                    url += (url.includes('?') ? '&' : '?') + `${param}=${encodeURIComponent(this.user.user_data.data[param])}`;
                });
                console.log(url, this.user.user_data.data, this.$props.skin.customActionButton);
                window.open(url, '_blank');
            }
        },
        openSupportModalJivo() {
            const jivoMobileElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'none'; // Ocultar el elemento móvil
                }
                this.$store.dispatch("setJivo_modal_flag", false);
            } else {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'block'; // Mostrar el elemento móvil
                    jivo_api.open()
                }
                this.$store.dispatch("setJivo_modal_flag", true);
                this.$store.dispatch("setMessage", false);
            }
        },
        showBalanceAction() {
            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        countDays(init) {
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
        getMovements() {
            this.$root.$emit('getMovementsHistory');
        },
        getIngresos() {
            this.$root.$emit('getIngresosHistory');
        },
        show_user_recharge() {
            this.$root.$emit("show_user_recharge");
        },
        balanceParsed(val, fiat) {
            let tasa = 1;
            if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
                tasa = this.currency.rate;
            }
            return (fiat != 'BETC' ? (fiat == 'USDT' ? val * tasa : val * tasa * this.user.user_data.data.tasa) : val).toFixed(2);
        },
        login() {
            document.getElementById('login_btn').click();
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        register() {
            document.getElementById('register_btn').click();
        },
        change_view(view) {
            this.$store.dispatch('setView', view);
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        }
    },
    watch: {
        showBalance(newVal, oldVal) {
            if (newVal) {
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
    },
    mounted() {
        this.$store.dispatch("setHeaderHeight", document.getElementById("mainHeader").offsetHeight + 5);
        this.$root.$on('openLogin', () => {
            this.login();
        });
    },
    created() {
        const self = this;
        let balanceRequestTime = 8000;
        var saldo_request = setInterval(function () {
            try {
                if (self.user.user_data.data && self.user.token != '') {
                    self.$store.dispatch('getProfile', {
                        token: self.user.token,
                        site_id: self.user.site_id,
                        site: self.user.site,
                        prefix: self.user.prefix,
                        playerId: self.user.user_data?.data?.user_id,
                        source: "main"
                    });
                } else {
                    clearInterval(saldo_request);
                }
            } catch (error) {
                this.$store.dispatch('logOut');
                clearInterval(saldo_request);
            }
        }, balanceRequestTime);
    }, beforeDestroy() {
        this.$root.$off('openLogin');
    }
}
</script>

<style>
.navbarCustom {
    border: none;
    background-color: #1c1c1c;
    /* Color de fondo por defecto */
    /* position: fixed; */
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
</style>